import { EmployeeDetailHeader } from "./components/EmployeeDetailHeader";
import { EmployeeDetailSidebar } from "./components/EmployeeDetailSidebar";
import { EmployeeDetailMain } from "./components/EmployeeDetailMain";
import { JSX } from "react";

export const EmployeeDetailPageContainer = (): JSX.Element => {
    return (
        <section className="p-employee-detail">
            <EmployeeDetailHeader />
            <section className="p-employee-detail__content">
                <EmployeeDetailSidebar />
                <EmployeeDetailMain />
            </section>
        </section>
    );
};
